import { useCallback } from 'react';

export const useCustomEvent = () => {
  const dispatchCustomEvent = useCallback(
    ({
      eventName,
      target,
      eventInit,
    }: {
      eventName: string;
      target: any;
      eventInit: CustomEventInit;
    }) => {
      target?.dispatchEvent(new CustomEvent(eventName, eventInit));
    },
    [],
  );

  return { dispatchCustomEvent };
};
